import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

import { NavioFitErrorBoundary } from '@/components/NavioFitErrorBoundary';
import { AuthProvider } from '@/context/AuthContext';
import { trpcClient, queryClient, TRPCProvider } from '@/lib/trpc';

import App from './App';
// Ecosystem canonical tokens FIRST, then app-local tailwind layers.
import '@navio-maritime/ui/styles.css';
import '@/styles/globals.css';

// Monitoring is optional and heavy. Keep its SDKs out of login/startup when no
// production keys are configured; the shared toolkit still owns init policy.
if (import.meta.env.VITE_SENTRY_DSN || import.meta.env.VITE_POSTHOG_KEY) {
  void import('@navio-maritime/platform/observability')
    .then(({ initObservability }) => {
      initObservability({
        product: 'navioworks-fit',
        sentry: { dsn: import.meta.env.VITE_SENTRY_DSN },
        posthog: { key: import.meta.env.VITE_POSTHOG_KEY },
      });
    })
    .catch((error: unknown) => {
      console.error('[observability] Failed to load monitoring:', error);
    });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <NavioFitErrorBoundary>
      <TRPCProvider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <BrowserRouter>
              <App />
              <Toaster position="top-right" duration={4000} richColors closeButton />
            </BrowserRouter>
          </AuthProvider>
        </QueryClientProvider>
      </TRPCProvider>
    </NavioFitErrorBoundary>
  </React.StrictMode>
);
